import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
    details: [],
    recipientInfoDetails: [],
    sockDraftOrderDetails: [],
    loading: false,
    checkoutDetails: [],
    draftOrderInvoiceDetails: []
  },
  getters: {
    details: state => state.details,
    list: state => state.list,
    recipientInfoDetails: state => state.recipientInfoDetails,
    sockDraftOrderDetails: state => state.sockDraftOrderDetails,
    checkoutDetails: state => state.checkoutDetails,
    loading: state => state.loading,
    draftOrderInvoiceDetails: state => state.draftOrderInvoiceDetails
  },
  actions: {
    fetchSingle({ commit }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/DraftOrdersQuery/" + id)
          .then(r => {
            commit("setDetails", r.data);
            commit("setLoading", false);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    fetchLatestRecords({ commit }) {
      return ajax
        .get("Sales/api/DraftOrdersQuery?DraftOrderState=2&Take=5&Skip=0")
        .then(r => {
          commit("setList", r.data.data);
        });
    },
    GetAllSeriesRelatedToCurrentDischrgePermission(
      { commit, dispatch },
      { storeId, shelveId, dischargePermissionId }
    ) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/SerialsOfStockQuery/" +
              storeId +
              "/" +
              shelveId +
              "/all-serials-of/" +
              dischargePermissionId
          )
          .then(r => {
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    // patch({ commit, dispatch }, { id, reasonOfReject }) {
    //   return ajax
    //     .patch(
    //       "Sales/api/DraftOrders/" + id + "/Status",
    //       { draftOrderId: id, reasonOfReject: reasonOfReject },
    //       { headers: { "Content-Type": "application/json" } }
    //     )
    //     .then(() => {});
    // },
    fetchRecipientInfo({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/BasketsQuery/draft-order/" + id + "/recipientInfo")
          .then(r => {
            commit("setRecipientInfoDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    sockDraftOrdersQuerySearch({ commit, dispatch }, Keyword) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/StockDraftOrdersQuery?Keyword=" +
              Keyword +
              "&Take=500&Skip=0"
          )
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    sockDraftOrder({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Inventory/api/StockDraftOrdersQuery/stock-draft-order/" + id)
          .then(r => {
            commit("setSockDraftOrderDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    draftOrderInvoice({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Inventory/api/StockDraftOrdersQuery/" + id + "/for-print/")
          .then(r => {
            commit("setDraftOrderInvoiceDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    scanBarcodeForCheckout({ commit }, { storeId, shelveId, stockId }) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/SerialsOfStockQuery/" +
              storeId +
              "/" +
              shelveId +
              "/" +
              stockId +
              "?take=10000&skip=0"
          )
          .then(r => {
            commit("setDraftOrderInvoiceDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    fetchSingleCheckout({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/CheckOutForDraftOrderTransactionsQuery/" + id)
          .then(r => {
            commit("setCheckoutDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    }
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    },
    setList(state, data) {
      state.list = data;
    },
    setRecipientInfoDetails(state, data) {
      state.recipientInfoDetails = data;
    },
    setSockDraftOrderDetails(state, data) {
      state.sockDraftOrderDetails = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setCheckoutDetails(state, data) {
      state.checkoutDetails = data;
    },
    setDraftOrderInvoiceDetails(state, data) {
      state.draftOrderInvoiceDetails = data;
    }
  }
};
